export const isPdfFile = (path: string) => {
  if (typeof path !== 'string') return false;
  const base = path.trim().toLowerCase().split('?')[0]?.split('#')[0] ?? '';
  return base.endsWith('.pdf');
};
